import React from "react";
import GridSpotImage from "../../../../../Survey/common/components/GridSpotImage";
import { readGridspotSelectedOptionIds } from "../../../../../Survey/helpers/gridspot";

export default function GridSpotHistoryAnswer({ answer, answeres }) {
  const question = answer?.question;
  const selectedOptionIds = readGridspotSelectedOptionIds(
    answeres[question?._id]?.value,
  );

  if (!selectedOptionIds.length) {
    return null;
  }

  const alt = question?.text
    ? String(question.text).replace(/<[^>]+>/g, "")
    : "Survey image";

  return (
    <div
      className="bg-white rounded-2xl p-2 shadow-sm"
      style={{ width: "min(280px, 85vw)" }}
    >
      <GridSpotImage
        question={question}
        selectedOptionIds={selectedOptionIds}
        readOnly
        alt={alt}
      />
    </div>
  );
}
